// frontend/src/data/GalleryData.js

const galleryPhotos = [
    { id: "lrr1", imageUrl: "/gallery/lrr1.webp", title: "Lil Rockstars Racing" },
    { id: "lrr2", imageUrl: "/gallery/lrr2.webp", title: "Lil Rockstars Racing" },
    { id: "lrr3", imageUrl: "/gallery/lrr3.webp", title: "Lil Rockstars Racing" },
    { id: "lrr4", imageUrl: "/gallery/lrr4.webp", title: "Lil Rockstars Racing" },
    { id: "lrr5", imageUrl: "/gallery/lrr5.webp", title: "Lil Rockstars Racing" },
    { id: "lrr6", imageUrl: "/gallery/lrr6.webp", title: "Lil Rockstars Racing" },
    { id: "lrr7", imageUrl: "/gallery/lrr7.webp", title: "Lil Rockstars Racing" },
    { id: "lrr8", imageUrl: "/gallery/lrr8.webp", title: "Lil Rockstars Racing" },
    { id: "lrr9", imageUrl: "/gallery/lrr9.webp", title: "Lil Rockstars Racing" },
    { id: "lrr10", imageUrl: "/gallery/lrr10.webp", title: "Lil Rockstars Racing" },
    { id: "lrr11", imageUrl: "/gallery/lrr11.webp", title: "Lil Rockstars Racing" },
    { id: "lrr12", imageUrl: "/gallery/lrr12.webp", title: "Lil Rockstars Racing" },
    { id: "lrr13", imageUrl: "/gallery/lrr13.webp", title: "Lil Rockstars Racing" },
    { id: "lrr14", imageUrl: "/gallery/lrr14.webp", title: "Lil Rockstars Racing" },
    { id: "lrr15", imageUrl: "/gallery/lrr15.webp", title: "Lil Rockstars Racing" },
    { id: "lrr16", imageUrl: "/gallery/lrr16.webp", title: "Lil Rockstars Racing" },
    { id: "lrr17", imageUrl: "/gallery/lrr17.webp", title: "Lil Rockstars Racing" },
    { id: "lrr18", imageUrl: "/gallery/lrr18.webp", title: "Lil Rockstars Racing" },
    { id: "lrr19", imageUrl: "/gallery/lrr19.webp", title: "Lil Rockstars Racing" },
    { id: "lrr20", imageUrl: "/gallery/lrr20.webp", title: "Lil Rockstars Racing" },
];

export default galleryPhotos;